import React, { useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import '../CSS/PowerBI.css';

const AALAC = () => {
  const [access_token, setAccessToken] = useState('');

  useEffect(() => {
    fetch('/api/hello')
      .then((response) => response.json())
      .then((data) => {
        setAccessToken(data.accessToken);
      })
      .catch((error) => {
        console.error('Error fetching PowerBI token:', error);
      });
  }, []);

  return (
    <div className="power-bi powerbi-only">
      <style>
        {`
          iframe {
            border: none;
          }
        `}
      </style>

      {access_token && (
        <PowerBIEmbed
          embedConfig={{
            type: 'report',
            id: '7ced6915-6993-4a74-84df-8bafcf095caf',
            embedUrl:
              'https://app.powerbi.com/reportEmbed?reportId=7ced6915-6993-4a74-84df-8bafcf095caf&groupId=8462ee1f-e8db-4f03-bba9-021eabab566f&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLUItUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
            accessToken: access_token,
            tokenType: models.TokenType.Aad,
            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: false,
                },
                pageNavigation: {
                  visible: false,
                },
              },

              navContentPaneEnabled: false,

              layoutType: models.LayoutType.Single,
              background: models.BackgroundType.Transparent,
            },
          }}
          eventHandlers={
            new Map([
              ['loaded', () => console.log('AAALAC report loaded')],
              ['rendered', () => console.log('AAALAC report rendered')],
              ['error', (event) => console.log(event.detail)],
            ])
          }
          cssClassName="reportClass"
          getEmbeddedComponent={(embeddedReport) => {
            window.AALACReport = embeddedReport;
          }}
        />
      )}
    </div>
  );
};

export default AALAC;